import { render, staticRenderFns } from "./WeeklyBudgetCompliance.vue?vue&type=template&id=b1523652"
import script from "./WeeklyBudgetCompliance.vue?vue&type=script&lang=js"
export * from "./WeeklyBudgetCompliance.vue?vue&type=script&lang=js"
import style0 from "./WeeklyBudgetCompliance.vue?vue&type=style&index=0&id=b1523652&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports